import { userAdressFormater } from "@/services/formater/userAdressFormater.js";
/**
 *
 * @param {Object} state
 * @param {Object} currentUser
 */
const SET_CURRENT_USER_IS_LOGGED_IN = (state, currentUserInfo) => {
  currentUserInfo ? (state.currentUser.isLoggedIn = currentUserInfo) : false;
};

/**
 *
 * @param {Object} state
 * @param {Object} currentUser
 */
const SET_CURRENT_USER_INFO = (state, currentUserInfo) => {
  const currentUser = state.currentUser;
  currentUserInfo.entity_id ? (currentUser.id = currentUserInfo.entity_id) : "";
  currentUserInfo.prefix ? (currentUser.prefix = currentUserInfo.prefix) : "";
  currentUserInfo.firstname ? (currentUser.firstName = currentUserInfo.firstname) : "";
  currentUserInfo.lastname ? (currentUser.lastName = currentUserInfo.lastname) : "";
  currentUserInfo.email ? (currentUser.email = currentUserInfo.email) : "";
};

const SET_CURRENT_SHIPPING_ADRESS = (state, currentUserInfo) => {
  console.info('SET_CURRENT_SHIPPING_ADRESS')
  const shipingAddress = currentUserInfo.shipping_address[0];
  shipingAddress ? (state.currentUserShippingAddress = userAdressFormater(shipingAddress)) : {};
};

const SET_CURRENT_BILLING_ADRESS = (state, currentUserInfo) => {
  const billingAddress = currentUserInfo.billing_address[0];
  billingAddress ? (state.currentUserBillingAddress = userAdressFormater(billingAddress)) : {};
};

export default {
  SET_CURRENT_USER_IS_LOGGED_IN,
  SET_CURRENT_USER_INFO,
  SET_CURRENT_SHIPPING_ADRESS,
  SET_CURRENT_BILLING_ADRESS,
};
